import { useMemo } from 'react';

import { ActivitiesContentType } from 'global/constants';
import { useGetDraftActivitiesFromCache } from 'approot/activity-builder/logic/hooks/use-get-draft-activities-from-cache';
import { getActivityNumber } from './activity.utils';

export const useActivityNumber = ({
  contentId,
  contentType,
  sectionId,
}: {
  contentId: number;
  contentType: ActivitiesContentType;
  sectionId: string;
}) => {
  const lesson = useGetDraftActivitiesFromCache({
    contentId,
    contentType,
  });

  const number = useMemo(() => {
    return lesson ? getActivityNumber(sectionId, lesson.sectionsOverview) : 0;
  }, [sectionId, lesson]);

  return {
    number,
  };
};
